module.exports = __webpack_public_path__ + "img/tutorial_img_1.ea382584.svg";